"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENT_PREFIX = "@@METRICS/";
var TRACK_EVENT = exports.TRACK_EVENT = EVENT_PREFIX + "/TRACK_EVENT";
var TRACK_PAGEVIEW = exports.TRACK_PAGEVIEW = TRACK_EVENT + "/TRACK_PAGEVIEW";

var metricsActionTypeRegex = new RegExp("^(" + TRACK_EVENT + "|" + TRACK_PAGEVIEW + ")$");
var isMetricsAction = exports.isMetricsAction = function isMetricsAction(action) {
  if (!action || !action.type) return false;
  return metricsActionTypeRegex.test(action.type);
};
//# sourceMappingURL=actionTypes.js.map